const isArrayType = field => field.mode === "REPEATED";
const isStruct = field => field.type === "RECORD";
const checkForComplexFields = schema => schema && schema.fields.some(f => isArrayType(f) || isStruct(f));

export { checkForComplexFields };
